import React from 'react';

/**
 * /demo entry point.
 * 
 * Sets up a demo session by injecting mock user identity and org context,
 * then forces a full page reload to /dashboard. A Navigate redirect won't
 * work because AuthProvider reads sessionStorage at mount time — we need
 * the storage values set BEFORE React mounts the provider tree.
 */
export const DemoPage: React.FC = () => {
  React.useEffect(() => {
    // Inject demo user identity (matches MOCK_USERS[1] "Admin Alice" for full admin experience)
    const demoUser = {
      id: 'user-alice',
      firstName: 'Demo',
      lastName: 'Visitor',
      fullName: 'Demo Visitor',
      primaryEmailAddress: { emailAddress: 'demo@orgsets.com' },
      imageUrl: 'https://picsum.photos/seed/demo/100/100',
      publicMetadata: { role: 'PRESIDENT' },
      username: 'demo-visitor'
    };

    localStorage.setItem('mock_user_identity', JSON.stringify(demoUser));
    localStorage.setItem('active_org', 'demo-org');
    sessionStorage.setItem('is_demo_session', 'true');

    // Full page reload ensures AuthProvider re-mounts and reads the new session flag
    window.location.href = '/dashboard';
  }, []);

  // Loading state while the effect runs
  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 border-4 border-black dark:border-white border-t-[#0044FF] rounded-full animate-spin mx-auto" />
        <p className="font-mono text-xs uppercase tracking-widest text-gray-500">
          Preparing your demo experience...
        </p>
      </div>
    </div>
  );
};
